import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1eeb58a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination-root" }
const _hoisted_2 = { class: "pager" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode()
const _hoisted_5 = { class: "total-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_arrow = _resolveComponent("icon-arrow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["n-f-page lft", [
                    {
                        'is-btn': _ctx.pagerInfo.pageNo != 1,
                        disabled: _ctx.pagerInfo.pageNo === 1
                    }
                ]]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)))
      }, [
        _createVNode(_component_icon_arrow),
        _createElementVNode("span", null, _toDisplayString(_ctx.t('common.prev')), 1)
      ], 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageNumbers, (ni, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["page", {
                    'is-page': ni != -1,
                    active: ni === _ctx.pagerInfo.pageNo
                }]),
          key: `pager-key-${i}`,
          onClick: ($event: any) => (_ctx.gotoPage(ni))
        }, _toDisplayString(_ctx.getPageLabel(ni)), 11, _hoisted_3))
      }), 128)),
      _createElementVNode("div", {
        class: _normalizeClass(["n-f-page rgt", [
                    {
                        'is-btn': _ctx.pagerInfo.pageNo != _ctx.pagerInfo.totalPage,
                        disabled: _ctx.pagerInfo.pageNo === _ctx.pagerInfo.totalPage
                    }
                ]]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.t('common.next')), 1),
        _hoisted_4,
        _createVNode(_component_icon_arrow)
      ], 2),
      _createTextVNode(" " + _toDisplayString(_ctx.t('common.topage')) + " ", 1),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.directPage) = $event)),
        onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onInputChange && _ctx.onInputChange(...args)))
      }, null, 544), [
        [_vModelText, _ctx.directPage]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t('common.totalpage', [_ctx.pagerInfo.totalSize])), 1)
  ]))
}